import React from "reactn"
import { graphql } from "gatsby"
import { Box,} from '@chakra-ui/react';
import { ColumnListing } from "./columns-listing";
import { ColumnCardData } from "./column-card-data";
import { StockistListing } from "./stockist-listing"
import { StoryListing } from "./story-listing"
import ContactForm from "./contact";
import InstagramFeed from "./instagramFeed"

export function BlockCard({ seo, isStory, blockCard, eager, location, }) {
  const {
    id,
    columns,
    showinstagram,
    iscontact,
    stockists, 
    stories
  } = blockCard
  return (
    <Box id={id} >
      <ColumnCardData  isStory={isStory} eager={eager} columnCardData={blockCard}/>    
      { showinstagram && <InstagramFeed /> }
      { iscontact && <ContactForm/> }
      { stockists && stockists.length > 0 && <StockistListing stockists={stockists} /> }
      { stories && stories.length > 0 && <StoryListing stories={stories} location={location}  seo={seo} /> }
      <ColumnListing  isStory={isStory} eager={eager} id={id} columns={columns} />
    </Box>
  );
}

export const query = graphql`
  fragment BlockCard on DatoCmsBlock {
    model { apiKey }
    id
    name
    title
    subtitle  
    text
    textNode {
      childMarkdownRemark {
        html
      } 
    }
    button {
      text
      color
      style
      link {
        ... on DatoCmsSinglepage {
          id: originalId
          slug        
        }
        ... on DatoCmsProductgroup {
          id: originalId
          slug
        }
      }
    }
    image {
      alt
      gatsbyImageData(
        placeholder: BLURRED,
        forceBlurhash: false,
        imgixParams: { invert: false }
      )
    }
    mobileimage {
      alt
      gatsbyImageData(
        placeholder: BLURRED,
        forceBlurhash: false,
        imgixParams: { invert: false }
      )
    }
    showinstagram
    iscontact
    stockists {
      ... on DatoCmsStockist {
        ...StockistCard
      }
    }
    stories {
      ... on DatoCmsStory {
        ...StoryCard
      }
    }
    columns {
      ... on DatoCmsColumn {
        ...ColumnCard
      }
    }
  }
`

export const storyQuery = graphql`
  fragment StoryBlockCard on DatoCmsBlock {
    model { apiKey }
    id
    name
    title
    subtitle
    text
    textNode {
      childMarkdownRemark {
        html
      } 
    }
    button {
      text      
      link {
        ... on DatoCmsSinglepage {
          id: originalId
          slug        
        }
        ... on DatoCmsProductgroup {
          id: originalId
          slug
        }
      }
    }
    imageGallery {
      alt
      gatsbyImageData(
        placeholder: BLURRED,
        forceBlurhash: false,
        imgixParams: { invert: false }
      )
    }
    image {
      alt
      gatsbyImageData(
        placeholder: BLURRED,
        forceBlurhash: false,
        imgixParams: { invert: false }
      )
    }
    iscontact
    stockists {
      ... on DatoCmsStockist {
        ...StockistCard
      }
    }
    stories {
      ... on DatoCmsStory {
        ...StoryCard
      }
    }
    columns {
      ... on DatoCmsColumn {
        ...ColumnCard
      }
    }
  }
`
export const storySummaryQuery = graphql`
  fragment StorySummaryBlockCard on DatoCmsBlock {
    model { apiKey }
    id
    name
    title
    subtitle
    text
    textNode {
      childMarkdownRemark {
        html
      } 
    }
    image {
      alt
      gatsbyImageData(
        width: 1024,
        forceBlurhash: false,
        imgixParams: { invert: false }
      )
    }
  }
`
